import './divider.scss';

const Divider: React.FC = () => <div className="divider" />;

export default Divider;